export const commandStatusEnum = {
    ACTIVE: 'ACTIVE',
    SUCCESS: 'SUCCESS',
    // @Deprecrated with Multi Stash CLI Feature.
    STAGED: 'STAGED',
    PARTIAL_SUCCESS: 'PARTIAL_SUCCESS',
    ERROR: 'ERROR',
    RUNNING: 'RUNNING',
} as const;

export type CommandStatusEnumType = keyof typeof commandStatusEnum;
